import { useMemo } from "react";
import type { WorkerFilters } from "@/domains/workers/types";
import type { WorkerDetailFragment } from "@/gql/graphql";
import { useSalonStore } from "@/lib/store/salon";
import { useWorkersQuery } from "./use-workers-query";

interface UseWorkersProps {
  filters?: WorkerFilters;
}

interface UseWorkersReturn {
  workers: WorkerDetailFragment[];
  loading: boolean;
  error: any;
  refetch: () => void;
  hasMore: boolean;
}

export const useWorkers = ({ filters = {} }: UseWorkersProps = {}): UseWorkersReturn => {
  const currentSalon = useSalonStore((state) => state.currentSalon);

  const {
    data: workersData,
    loading: workersLoading,
    error: workersError,
    refetch: refetchWorkers,
    hasMore,
  } = useWorkersQuery({
    salonId: currentSalon?.id,
    filters,
  });

  // Transform workers data
  const workers = useMemo(() => {
    if (!workersData?.workers?.workers) {
      return [];
    }

    return workersData.workers.workers as WorkerDetailFragment[];
  }, [workersData]);

  const loading = workersLoading;
  const error = workersError;

  const refetch = () => {
    refetchWorkers();
  };

  return {
    workers,
    loading,
    error,
    refetch,
    hasMore,
  };
};
